<template>
  <div>
    <div class="header"></div>
    <div class="container">
      <div id="" v-for="(item, index) in goodsTypeList.data" :key="index">
        <div class="title">
          <div class="title-l">
            {{ item.type_name }}
            <span class="rxlj">任选{{ item.optional_sum }}件</span>
            <span class="yx"
              >已选{{ includeData(item.id) }}/{{ item.optional_sum }}
            </span>
          </div>
          <div
            @click="onClickShow(-1)"
            v-if="tabIndex === index"
            class="title-r"
          >
            <sapn class="text">收起</sapn> <span class="icon">︿</span>
          </div>
          <div @click="onClickShow(index)" v-else class="title-zk">
            <sapn class="text">展开</sapn>
          </div>
        </div>
        <div id="" v-if="tabIndex === index">
          <div class="bg">
            <div
              class="list"
              :class="
                isShowData
                  ? 'item animated fadeInDown '
                  : 'item animated fadeInUp'
              "
              v-for="(items, indexs) in item.goods_list"
              :key="indexs"
            >
              <div class="item">
                <div class="t-l">
                  <div>{{ items.type_name }}</div>
                  <div v-for="(a, index) in items.info" :key="index + 1">
                    {{ a }}
                  </div>
                </div>
                <div id="">
                  <div class="btn-r">
                    <div class="btn1" v-if="includeGoodsSum(item.id, items.id)">
                      <div
                        class="btn_l l"
                        @click="onSubtract({ items, indexs, itemId: item.id })"
                      >
                        -
                      </div>
                      <div class="btn_l q">
                        {{ includeGoodsSum(item.id, items.id) }}
                      </div>
                      <div
                        class="btn_l r"
                        @click="selectGoods({ items, indexs, itemId: item.id })"
                      >
                        +
                      </div>
                    </div>
                    <div
                      class="btn2"
                      v-else
                      @click="selectGoods({ items, indexs, itemId: item.id })"
                    >
                      <div>+</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="flexl">
        <div class="flex_l">
          <div class="flex">
            <label>已选:</label><span>{{ snumber }}/{{ amount }}</span>
          </div>
          <div class="flex">
            <span
              v-for="(item, index) in goodsTypeList.data"
              :key="index"
              :class="includeData(item.id) == item.optional_sum ? 'org' : ''"
              >{{ item.type_name }} {{ includeData(item.id) }}/{{
                item.optional_sum
              }};</span
            >
          </div>
        </div>
        <div class="flex_r" @click="submint">提交订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import { postOptionalGoodsCardType } from "@api/user";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  name: "AddBlackCard",
  data() {
    return {
      isShowData: true,
      params: {},
      dataObj: [],
      tabIndex: 0,
      goodsIndex: "",
      sum: 0,
      submintData: [],
      addArray: [],
      goodsTypeList: {},
      limit_area: []
    };
  },
  created() {
    let { u, p, t } = this.$route.query;
    this.params = {
      group_id: t,
      number: u,
      password: p
    };
    // 创建存储商品数据
    this.getData();
  },
  computed: {
    amount() {
      let sum = this.goodsTypeList.data.map(ite => ite.optional_sum);
      return this.jsum(sum);
    },
    snumber() {
      let dataObj = this.dataObj.map(item => item.data).flat();
      return dataObj.length;
    }
  },
  methods: {
    jsum(arr) {
      var s = 0;
      for (var i = arr.length - 1; i >= 0; i--) {
        s += arr[i];
      }
      return s;
    },
    submint() {
      let dataObj = this.dataObj.map(item => item.data).flat();
      let obj = dataObj.map(m => m.id);
      console.log("提交数据", obj);
      console.log("满足条件", this.amount);
      let { u, p, t } = this.$route.query;
      let that = this;
      if (obj.length == that.amount) {
        that.$router.push({
          name: "SelectOptionalGoodsCard",
          query: {
            g: JSON.stringify(obj),
            u,
            p,
            t,
            l: this.limit_area
          }
        });
      } else {
        console.log("选择条件必须满足", that.amount);
        Toast(`选择条件必须满足(${that.amount})件商品`);
      }
    },
    onClickShow(index) {
      this.tabIndex = index;
    },
    onSubtract(item) {
      let index = this.dataObj
        .filter(it => it.id == item.itemId)[0]
        .data.findIndex(e => e.id == item.items.id);
      let lenItem = this.dataObj.filter(it => it.id == item.itemId)[0].data;
      if (lenItem[index] && lenItem[index].id === item.items.id) {
        this.dataObj
          .filter(it => it.id == item.itemId)[0]
          .data.splice(index, 1);
      } else {
        console.log("false");
      }
    },
    //
    selectGoods(item) {
      console.log("=--==-=->", item);
      this.goodsIndex = item.indexs;
      this.goodsInfo = item;
      let arr = this.dataObj.filter(res => res.id == item.itemId)[0];
      if (arr.data.length < arr.sum) {
        // 选择还是那个品加入数组
        this.dataObj.filter(res => {
          if (res.id == item.itemId) {
            res.data.push(item.items);
            return res;
          }
        });
      } else {
        Toast(`该品类只能额选择 (${arr.sum}) 件`);
      }
    },
    includeData(e) {
      let data = this.dataObj.filter(item => item.id == e)[0].data;
      return data.length;
    },
    // 查询数组对应商品数量
    includeGoodsSum(e, id) {
      let sum = this.dataObj
        .filter(item => item.id == e)[0]
        .data.filter(items => items.id == id);
      return sum.length;
    },
    getData() {
      let data = this.params;
      postOptionalGoodsCardType(data).then(res => {
        res.data.forEach(x => {
          x.goods_list.forEach(y => {
            y.info = y.info ? y.info.split("<br/>") : [];
          });
        });
        this.goodsTypeList = res;
        this.limit_area = res.data[0].limit_area;
        this.dataObj = this.goodsTypeList.data.map(item => {
          return {
            id: item.id,
            data: [],
            sum: item.optional_sum
          };
        });
      });
    }
  }
};
</script>

<style scoped>
body {
  background-color: #f9f9f9;
}
.header {
  width: 100%;
  height: 200px;
  background: linear-gradient(180deg, #00a55e 0%, #ffffff 100%);
}
.container {
  width: 90%;
  padding: 10px;
  background: #fff;
  border-radius: 8px;
  margin: auto;
  position: relative;
  top: -120px;
}
.container .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}
.container .title-l {
  font-size: 18px;
  font-weight: bold;
}
.container .title-l .rxlj,
.container .title-l .yx {
  font-size: 15px;
  font-weight: bold;
}

.container .title-l .yx {
  color: #f95244;
  padding-left: 5px;
}
.btn-r2 {
  border-radius: 100%;
  width: 20px;
  height: 20px;
  text-align: center;
  background-color: #9b9b9b;
  color: #f7f7f7;
}
.btn-r3 {
  border-radius: 100%;
  width: 20px;
  height: 20px;
  text-align: center;
  background-color: #f95244;
  color: #f7f7f7;
}
.container .title-zk {
  border: 1px solid rgba(249, 82, 68, 0.48);
  border-radius: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  height: 30px;
  width: 83px;
  background-color: #f95244;
  color: #fff;
  font-weight: bold;
}
.container .title-zk .text {
  font-size: 10px;
}
.btn2 {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f95244;
  color: #ffffff;
  font-weight: bold;
  margin-right: 10px;
}
.container .title-r {
  height: 30px;
  width: 83px;
  border: 1px solid rgba(249, 82, 68, 0.48);
  border-radius: 24px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.container .title-r .text,
.container .title-r .icon {
  font-size: 13px;
  color: #f95244;
  font-weight: bold;
}
.container .title-r .icon {
  position: relative;
  top: -2px;
  left: 4px;
}
.list {
  margin-top: 17px;
  width: 100%;
  border-radius: 10px;
  background: #f7f7f7;
  padding: 5px;
}
.list .item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list .item .t-l {
  font-size: 14px;
  width: 75%;
}
.list .item .btn-r .btn1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.btn-r {
  border-radius: 0.4em;
  /* border: 1px solid #B4B4B4; */
}
.list .item .btn-r .btn1 .btn_l {
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 25px;
}
.list .item .btn-r .btn1 .q {
  border-top: 1px solid #b4b4b4;
  border-bottom: 1px solid #b4b4b4;
  border-left: none;
  border-right: none;
}
.list .item .btn-r .btn1 .r {
  background-color: #f95244;
  border: 1px solid #f95244;
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
  font-size: 20px;
  color: #f7f7f7;
}

.list .item .btn-r .btn1 .r:active {
  background-color: #f81805;
}

.list .item .btn-r .btn1 .l {
  border: 1px solid #b4b4b4;
  border-bottom-left-radius: 15px;
  border-top-left-radius: 15px;
  font-size: 20px;
}
.org {
  color: #f95244;
}
.footer {
  width: 100%;
  padding: 15px 10px 33px 10px;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
}
.footer .flexl {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
}
.footer .flex_l {
  display: flex;
  flex-direction: column;
  width: 70%;
  justify-content: center;
}
.footer .flex_l .flex {
  font-size: 17px;
}
.footer .flex_l .flex label {
  font-weight: 600;
}

.footer .flex_l .flex span {
  font-size: 13px;
  display: contents;
}

.footer .flex_r {
  background: rgba(249, 82, 68, 0.7);
  width: 94px;
  height: 40px;
  font-size: 15px;
  line-height: 40px;
  border-radius: 30px;
  text-align: center;
  color: #fff;
}

.footer .flex_r:active {
  background-color: #f81805;
}

.bor {
  height: 20px;
}
</style>
